import { render, staticRenderFns } from "./CustomerNavHeader.vue?vue&type=template&id=70ee009d&scoped=true&"
import script from "./CustomerNavHeader.vue?vue&type=script&lang=js&"
export * from "./CustomerNavHeader.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNavHeader.vue?vue&type=style&index=0&id=70ee009d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee009d",
  null
  
)

export default component.exports